import { store } from './../index';
export function flowUrl(){
    let flowType = store && store.getState && store.getState().app && store.getState().app.flowType;        
    let currentpath = window.location && window.location.pathname ? window.location.pathname.split("/") : '';
    let currentpage = currentpath[currentpath.length - 1]
    currentpage = currentpage.toLowerCase();
   // let result = flowType.toLowerCase() + "flow" + " " + currentpage.toLowerCase()
    //result = result.toString();
    flowType = flowType.toLowerCase()+"flow"
    let bodyclass  = document.body.classList
    if(bodyclass.contains('qualification'))
    {
        document.body.classList.remove('qualification');
    }
    else if(bodyclass.contains('buildproducts'))
    {
        document.body.classList.remove('buildproducts')
    }
    else if(bodyclass.contains('checkout'))
    {
        document.body.classList.remove('checkout')
    }
    else{
        document.body.classList.add(currentpage)
    }
    if(flowType === 'ncflow' || flowType === 'afflow')
    document.body.classList.add(flowType);
    document.body.classList.add(currentpage);
    console.log("result",currentpage);
}